import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';

import { addPageData, navigateWizard } from '../../actions';
import Button from '../../components/Button';
import Checkbox from '../../components/Checkbox';
import PageLayout from '../../components/PageLayout';
import YearMonthPicker from '../../components/YearMonthPicker';
import analytics from '../../lib/analytics';
import * as payloadFactory from '../../lib/pageDataPayloadFactory';

const changeState = (event, setStateFn) => {
  const { value } = event.currentTarget;
  setStateFn(value);
};

const FullTimeEmploymentDatesPage = ({
  initialStartMonth,
  initialStartYear,
  initialWillBeEmployed,
  dispatchWizardNav,
  dispatchAddPageData,
}) => {
  const [startMonth, setStartMonth] = useState(initialStartMonth);
  const [startYear, setStartYear] = useState(initialStartYear);
  const [willBeEmployedDuringCourse, setWillBeEmployedDuringCourse] = useState(
    initialWillBeEmployed,
  );
  const currentDate = new Date(Date.now());
  const currentYear = currentDate.getFullYear();

  const handleSubmit = event => {
    event.preventDefault();

    if (isInvalid) return;

    analytics.sendEvent('Click - Next', 'full-time-employment-dates');

    const fullTimeEmploymentDatesPayload = payloadFactory.createAddPageDataPayload(
      'fullTimeEmploymentDates',
      {
        startMonth,
        startYear,
      },
    );

    const fullTimeEmployedDuringCoursePayload = payloadFactory.createAddPageDataPayload(
      'fullTimeEmployedDuringCourse',
      willBeEmployedDuringCourse,
    );

    dispatchAddPageData(fullTimeEmploymentDatesPayload);
    dispatchAddPageData(fullTimeEmployedDuringCoursePayload);
    dispatchWizardNav({ dir: 'fwd' });
  };

  const changeWillBeEmployedDuringCourse = event =>
    setWillBeEmployedDuringCourse(event.target.checked);

  const isInvalid = startMonth === '' || startYear === '' || !willBeEmployedDuringCourse;

  return (
    <PageLayout
      title="When did you join the company?"
      helpText="Remember your payments start 3 months after the last payment we make to the school.
                It's important that you plan to continue working through the course."
    >
      <form onSubmit={handleSubmit}>
        <YearMonthPicker
          month={startMonth}
          year={startYear}
          minYear={1980}
          maxYear={currentYear}
          onMonthChange={e => changeState(e, setStartMonth)}
          onYearChange={e => changeState(e, setStartYear)}
          yearId="start-year"
          monthId="start-month"
        />

        <div className="row-spacer">
          <Checkbox
            checkboxId="will-be-employed-during-course"
            isChecked={willBeEmployedDuringCourse}
            handleChange={changeWillBeEmployedDuringCourse}
          >
            I plan to continue working during my studies.
          </Checkbox>
        </div>

        <div className="row-spacer">
          <Button type="submit" isDisabled={isInvalid}>
            Next
          </Button>
        </div>
      </form>
    </PageLayout>
  );
};

FullTimeEmploymentDatesPage.propTypes = {
  initialStartMonth: PropTypes.string.isRequired,
  initialStartYear: PropTypes.string.isRequired,
  initialWillBeEmployed: PropTypes.bool.isRequired,
  dispatchWizardNav: PropTypes.func.isRequired,
  dispatchAddPageData: PropTypes.func.isRequired,
};

const mapStateToProps = reduxStore => ({
  initialStartMonth: reduxStore.builder.ui.fullTimeEmploymentDates.startMonth,
  initialStartYear: reduxStore.builder.ui.fullTimeEmploymentDates.startYear,
  initialWillBeEmployed: reduxStore.builder.ui.fullTimeEmployedDuringCourse,
});

const mapDispatchToProps = {
  dispatchWizardNav: navigateWizard,
  dispatchAddPageData: addPageData,
};

export { FullTimeEmploymentDatesPage, mapStateToProps, mapDispatchToProps };
export default connect(mapStateToProps, mapDispatchToProps)(FullTimeEmploymentDatesPage);
